export default __webpack_public_path__ + "static/intermision_one-8d64d878cb20066796b926f94478fb3c.jpg";